<template>
  <div class="top-nav">
    <el-row :gutter="20">
      <el-col :xs="{span:20, push:1}" :sm="{span:20, push:1}" :md="{span:20, push:1}" :lg="12" :xl="12">
        <div class="top-title">
          <el-image class="top-title-logo" :fit="'fill'" :src="logoUrl" alt="homapp_logo"  @click="handleClick" />&nbsp;
          <span v-if="isLargeScreen" class="top-title-realtor">REALTOR<sup>®</sup></span>
          <span class="top-title-realtor-name">&nbsp;{{realtorName}}</span>
        </div>
      </el-col>
      <el-col :xs="4" :sm="4" :md="4" :lg="12" :xl="12">
        <div class="top-menu">
          <div v-if="isLargeScreen">
            <el-menu mode="horizontal" :default-active="activeIndex" @select="handleSelect">
              <el-menu-item index="1"><span class="top-menu-item">{{menu[0]}}</span></el-menu-item>
              <el-menu-item index="2"><span class="top-menu-item">{{menu[1]}}</span></el-menu-item>
              <el-menu-item index="3"><span class="top-menu-item">{{menu[2]}}</span></el-menu-item>
              <el-menu-item index="4"><span class="top-menu-item">{{menu[3]}}</span></el-menu-item>
              <!-- <el-menu-item index="5"><span class="top-menu-item">{{menu[4]}}</span></el-menu-item> -->
              <el-menu-item index="6">
                <el-switch 
                  v-model="switchValue" 
                  inline-prompt
                  active-text="EN"
                  inactive-text="中" 
                  size="large" 
                  style="--el-switch-on-color: #3D80B4; --el-switch-off-color: #ff4949; padding-top: 8px;"
                />
              </el-menu-item>
            </el-menu>
          </div>
          <div v-else>
            <el-button @click="handleOpen"><el-icon><Fold /></el-icon></el-button>
            <el-drawer v-model="isOpenDrawer" :show-close="false" :append-to-body="true" size="40%" :before-close="handleClose">
              <el-menu mode="vertical" :default-active="activeIndex" @select="handleSelect">
                <el-menu-item index="1"><span class="top-menu-item">{{menu[0]}}</span></el-menu-item>
                <el-menu-item index="2"><span class="top-menu-item">{{menu[1]}}</span></el-menu-item>
                <el-menu-item index="3"><span class="top-menu-item">{{menu[2]}}</span></el-menu-item>
                <el-menu-item index="4"><span class="top-menu-item">{{menu[3]}}</span></el-menu-item>
                <!-- <el-menu-item index="5"><span class="top-menu-item">{{menu[4]}}</span></el-menu-item> -->
                <el-menu-item index="6">
                  <el-switch 
                    v-model="switchValue" 
                    inline-prompt
                    active-text="EN"
                    inactive-text="中" 
                    size="large" 
                    style="--el-switch-on-color: #3D80B4; --el-switch-off-color: #ff4949; padding-top: 8px;"
                  />
                </el-menu-item>
              </el-menu>
            </el-drawer>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>


<script>
import { Fold } from '@element-plus/icons-vue'
import { Lang } from '@/utils/language'
export default {
  name: 'TopNav',
  components: { Fold },
  props: {
    realtor: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      isLargeScreen: this.$store.state.largeScreen,
      isOpenDrawer: false,
      activeIndex: '1',
      switchValue: true,
      logoUrl: require('@/assets/logo.png'),
      realtorName: this.realtor,
    }
  },
  computed: {
    menu() {
      if (this.switchValue) {
        this.$store.commit('changeLang', 'en')
        return Lang.Menu.en;
      } else {
        this.$store.commit('changeLang', 'cn')
        return Lang.Menu.cn;
      };
    }
  },
  watch: {
    realtor(newVal) {
      this.realtorName = newVal;
    }
  },
  methods: {
    handleOpen(){
      this.isOpenDrawer = true;
    },
    handleClose(){
      this.isOpenDrawer = false;
    },
    handleClick() {
      window.open('https://www.homapp.com', '_blank');
    },
    handleSelect(idx) {
      document.body.style.overflow = 'auto'; // 或者使用 'scroll'
      switch(idx) {
        case '1':
          this.$router.push({ name: 'home' });
          break;
        case '2':
          this.$router.push({ name: 'mls' });
          break;
        case '3':
          this.$router.push({ name: 'featured' });
          break;
        case '4':
          this.$router.push({ name: 'sold' });
          break;
        case '5':
          this.$router.push({ name: 'about' });
          break;
        default:
      }
      this.handleClose();
    },
  }
}
</script>


<style lang="scss">
@import '@/assets/variables.scss';
.top-nav {
  z-index: 1;
  height: $top-height;
  border-bottom: 1px solid rgba(144, 147, 153, 0.2);
  background-color: white;
}
.top-title {
  padding-top: 8px;
  font-size: 1.8em;
  font-weight: 700;
  text-align: left;
}
.top-title-logo {
  width:50px; 
  height:50px;
  cursor: pointer;
  vertical-align: middle;
}
.top-title-realtor {
  // display: inline;
  color: black;
  vertical-align: middle;
}
.top-title-realtor-name {
  // color: $theme-color;
  color: var(--theme-color); // 使用CSS变量
  vertical-align: middle;
}
.top-menu {
  padding-top: 10px;
  text-align: right;
}
.top-menu-item {
  font-size: 1.3em;
}
@media screen and (min-width: 1201px) {
}
@media screen and (max-width: 1200px) {
}
</style>
